import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-email-error',
  imports: [
    ButtonModule,
    RouterModule,
    TranslatePipe
  ],
  templateUrl: './email-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class EmailErrorComponent {

}
